// Configuration for waitlist functionality
export const WAITLIST_CONFIG = {
  // Authorized email addresses that have full access
  AUTHORIZED_EMAILS: ['aalvarado7818@gmail.com'],
  
  // Launch date information
  LAUNCH_DATE: '2026',
  
  // Messages
  MESSAGES: {
    WAITLIST_ENROLLMENT: {
      title: "🎉 You're on the Release Waitlist!",
      subtitle: "Thank you for signing up! We're launching in 2026.",
      description: "You can create and edit lease agreements now, but printing and subscriptions will be available at launch.",
      chipLabel: "Waitlist Member"
    },
    PRINTING_RESTRICTED: "Printing is not available during the waitlist period. Launching in 2026.",
    COMING_SOON: "Coming Soon in 2026!",
    BUTTON_TEXT: "Coming Soon - 2026"
  },
  
  // Features that will be available at launch
  UPCOMING_FEATURES: [
    "Print unlimited lease agreements",
    "Download PDF versions of your leases", 
    "Subscribe for just $1/month"
  ]
};

// Helper function to check if user has access to printing and subscriptions
export const hasPrintingAccess = (userEmail: string | null): boolean => {
  if (!userEmail) return false;
  return WAITLIST_CONFIG.AUTHORIZED_EMAILS.includes(userEmail);
};

// Helper function to check if user has subscription access
export const hasSubscriptionAccess = (userEmail: string | null): boolean => {
  return hasPrintingAccess(userEmail);
};

// Helper function to get waitlist status for display
export const getWaitlistStatus = (userEmail: string | null) => {
  const hasAccess = hasPrintingAccess(userEmail);
  return {
    hasAccess,
    isWaitlistMember: !hasAccess,
    status: hasAccess ? 'authorized' : 'waitlist'
  };
}; 